module.exports = __webpack_public_path__ + "img/tj-card-bg.1454f297.png";